// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B3Iljdt9XH_Ol7 {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  width: -moz-fit-content;
  padding: var(--ds-space-025, 2px) var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-accent-gray-subtler, rgba(255, 255, 255, 0.69));
  color: var(--ds-text, #172b4d);
  font-size: 11px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 16px;
}
.d50CrvtHBv7DjY {
  background-color: var(--dynamic-nav-item-pressed);
  color: var(--dynamic-text);
}
.MoB2txsI60G5kh {
  padding: var(--ds-space-025, 2px) var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-neutral-bold, #44546f);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 11px;
  font-weight: var(--ds-font-weight-bold, 700);
  line-height: 16px;
  text-transform: uppercase;
}
`, ""]);
// Exports
export var boardTemplateBadge = `B3Iljdt9XH_Ol7`;
export var transparent = `d50CrvtHBv7DjY`;
export var bold = `MoB2txsI60G5kh`;
export default ___CSS_LOADER_EXPORT___;
